import React from "react";
import { Link } from "react-router-dom";
import Icon from "../components/AppIcon";

const NotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center p-8 max-w-md">
        <div className="flex justify-center mb-6">
          <div className="w-24 h-24 rounded-full bg-primary-50 flex items-center justify-center">
            <Icon name="FileQuestion" size={48} className="text-primary-600" />
          </div>
        </div>
        <h1 className="text-4xl 3xl:text-6xl 4xl:text-7xl 5xl:text-8xl 6xl:text-9xl font-bold text-primary mb-4">404</h1>
        <h2 className="text-2xl 3xl:text-4xl 4xl:text-5xl 5xl:text-6xl 6xl:text-7xl font-semibold text-primary mb-4">Page Not Found</h2>
        <p className="text-text-secondary 3xl:text-xl 4xl:text-2xl 5xl:text-3xl 6xl:text-4xl mb-8">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>
        <Link
          to="/home"
          className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base 3xl:text-xl 4xl:text-2xl 5xl:text-3xl 6xl:text-4xl font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
        >
          <Icon name="Home" size={20} className="mr-2" />
          Back to Homepage
        </Link>
      </div>
    </div>
  );
};

export default NotFound;